export function getToken(email) {
    return window.sessionStorage.getItem(`inbox_${email}`);
}
